import type { Thing, WithContext } from 'schema-dts';
import type { BaseLinkedDataSchema } from './types/baseLinkedDataSchema.ts';

/**
 * @deprecated Use jsonLdScript with schema-dts types instead
 */
export function addLinkedDataSchema(schema: BaseLinkedDataSchema) {
	const jsonSchema = JSON.stringify({
		'@context': 'https://schema.org',
		...schema,
	});

	const script = document.createElement('script');
	script.type = 'application/ld+json';
	script.innerHTML = jsonSchema;
	script.dataset.type = schema['@type'];

	document.head.appendChild(script);
}

export function jsonLdScript<T extends Thing>(json: WithContext<T>) {
	const jsonSchema = JSON.stringify(json);

	const script = document.createElement('script');
	script.type = 'application/ld+json';
	script.innerHTML = jsonSchema;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	script.dataset.type = (json as unknown as { '@type': string })['@type'];

	document.head.appendChild(script);
}
